import ResetPasswordForm from "@/components/auth/ResetPasswordForm";
import SEO from "@/components/seo/SEO";

export default function ResetPassword() {
  return (
    <>
      <SEO title="Reset Password" noindex />
      <div className="min-h-screen flex items-center justify-center bg-gray-50 reset-password-page">
        <style>{`
          .reset-password-page input,
          .reset-password-page label {
            color: #111827 !important;
          }
        `}</style>
        <div className="w-full max-w-md p-8 bg-white rounded-xl shadow-sm">
          <div className="mb-8 text-center">
            <h1 className="text-2xl font-semibold text-gray-900">
              Reset Password
            </h1>
            <p className="mt-2 text-sm text-gray-500">
              Enter your new password below
            </p>
          </div>
          <ResetPasswordForm />
        </div>
      </div>
    </>
  );
}
